<template>
  <div v-if="!!contracts.length">
    <v-card color="transparent" flat>
      <v-row class="px-3 grey--text">
        <v-col cols="1" class="py-0">
          <div class="font-weight-medium caption py-0 px-4">
            {{ $t("contract.list.headers.number") }}
          </div>
        </v-col>
        <v-col cols="3" class="py-0">
          <div class="font-weight-medium caption py-0 px-4">
            {{ $t("contract.list.headers.address") }}
          </div>
        </v-col>
        <v-col cols="2" class="py-0">
          <div class="font-weight-medium caption py-0 px-4">
            {{ $t("contract.list.headers.date") }}
          </div>
        </v-col>
        <v-col cols="2" class="py-0">
          <div class="font-weight-medium caption py-0 px-4">
            {{ $t("contract.list.headers.owners") }}
          </div>
        </v-col>
        <v-col cols="2" class="py-0">
          <div class="font-weight-medium caption py-0 px-4">
            {{ $t("contract.list.headers.tenant") }}
          </div>
        </v-col>
        <v-col cols="2" class="py-0">
          <div class="font-weight-medium caption py-0 px-4">
            {{ $t("contract.list.headers.state") }}
          </div>
        </v-col>
      </v-row>
    </v-card>
    <template v-for="contract in contracts">
      <v-hover :key="contract.id" v-slot="{ hover }">
        <v-card
          @click="
            $router.push({ name: 'Contract', params: { id: contract.id } })
          "
          :class="hover ? 'elevation-3' : 'elevation-0'"
          class="col-12 my-2 px-0 py-1 d-flex align-center flex-wrap rounded-xl"
        >
          <v-col cols="1" class="py-0">
            <v-card-title class="py-0 text-subtitle-2">
              {{ contract.id }}
            </v-card-title>
          </v-col>
          <v-col cols="3" class="py-0">
            <v-card-title class="py-0 text-subtitle-1">
              {{ contract.property.fullAddress }}
            </v-card-title>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-card-title
              v-if="
                !(contract.state == 'draft') &&
                  contract.startsAt &&
                  contract.endsAt
              "
              class="py-0 text-subtitle-1"
            >
              {{ contract.startsAt.split("-")[2] }}/{{
                contract.startsAt.split("-")[1]
              }}/{{ contract.startsAt.split("-")[0] }}
              -
              {{ contract.endsAt.split("-")[2] }}/{{
                contract.endsAt.split("-")[1]
              }}/{{ contract.endsAt.split("-")[0] }}
            </v-card-title>
            <v-card-title class="py-0 text-subtitle-1 grey--text">
              {{ contract.duration }} Meses
            </v-card-title>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-card-title
              v-if="contract.owner[0] && contract.owner[0].profile"
              class="py-0 text-subtitle-1"
            >
              {{ contract.owner.map(o => o.profile.name).join(", ") }}
            </v-card-title>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-card-title
              v-if="contract.tenant[0] && contract.tenant[0].profile"
              class="py-0 text-subtitle-1"
            >
              {{ contract.tenant[0].profile.name }}
            </v-card-title>
          </v-col>
          <v-col cols="1" class="py-0">
            <div class="text-center text-subtitle-1">
              {{ $t("contract.list.state." + contract.state) }}
            </div>

            <div
              v-if="contract.rescission"
              class="px-2 text-center caption rounded-lg primary white--text"
            >
              Rescisión
            </div>
          </v-col>
          <v-col cols="1" class="py-0 text-right">
            <v-btn @click.stop="deleting = contract.id" icon>
              <v-icon color="darken-1">mdi-delete</v-icon>
            </v-btn>
            <v-btn
              @click.stop="
                $router.push({
                  name: 'EditContract',
                  params: { id: contract.id }
                })
              "
              icon
            >
              <v-icon color="darken-1">mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-card>
      </v-hover>
    </template>

    <Modal ref="deleting">
      <v-card>
        <v-card-title>
          {{ $t("contract.show.delete_modal.title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("contract.show.delete_modal.confirm_message") }}
        </v-card-text>
        <v-card-actions class="px-6 py-3 justify-end">
          <v-spacer></v-spacer>
          <v-btn text @click.stop="deleting = null">
            {{ $t("action.cancel") }}
          </v-btn>
          <v-btn color="primary" @click.stop="deleteContract">
            {{ $t("action.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </Modal>
  </div>
  <div class="fill-width" v-else>
    <v-card color="transparent" flat>
      <v-banner color="info lighten-1" class="white--text" text type="info">
        <span>{{ $t("contract.list.no_contracts_found") }}</span>
        <router-link :to="{ name: 'CreateContract' }">{{
          $t("action.click_here")
        }}</router-link
        >.
      </v-banner>
    </v-card>
  </div>
</template>

<script>
import Modal from "@/components/modals/NoActivator";
import { DeleteContract } from "@/graphql/mutations/contracts";

export default {
  data() {
    return {
      deleting: null
    };
  },

  props: ["contracts"],

  components: {
    Modal
  },

  watch: {
    deleting(newVal) {
      newVal == null
        ? (this.$refs.deleting.dialog = false)
        : (this.$refs.deleting.dialog = true);
    }
  },

  methods: {
    deleteContract() {
      this.$apollo
        .mutate({
          mutation: DeleteContract,
          variables: {
            input: {
              contractId: this.deleting
            }
          }
        })
        .then(res => {
          if (res.data.deleteContract.success) {
            this.$refs.deleting.dialog = false;
            this.$emit("reload");
          }
        });
    }
  }
};
</script>
